import services from '../../../services'

const state = {
  info: {}
}
const actions = {
  async findDevices ({commit}, query) {
    return await services.device_findDevices(query)
  },
  async findByQuery ({commit}, query) {
    return await services.device_findByQuery(query)
  },
  async add ({commit}, options) {
    return await services.device_add(options)
  },
  async updateBySn ({commit}, options) {
    return await services.device_updateBySn(options.query.sn, options.body);
  },
  async updateMany ({commit}, options) {
    return await services.device_updateMany(options);
  },
  async deleteBySn ({commit}, query) {
    return await services.device_deleteBySn(query)
  },
  async findAll ({commit}, query) {
    return await services.device_findAll(query)
  },
  async importDevice ({commit}, options) {
    return await services.device_importDevice(options)
  },
  // async downloadFile ({commit}, query) {
  //   return await services.device_downloadFile(query)
  // },
  async exportDevice ({commit}, options) {
    return await services.device_exportDevice(options)
  },
  async deviceReset ({commit}, options) {
    return await services.device_reset(options)
  },
  async findDevicelogs ({commit}, options) {
    return await services.device_findDevicelogs(options)
  }
}

const mutations = {
  deviceInfo(state, payload) {
    let deviceInfo = payload || {}
    state.info = deviceInfo
  }
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/device.js